import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GirisComponent } from '../giris/giris.component';
import { AnasayfaComponent } from '../anasayfa/anasayfa.component';
import { KullaniciGruplarComponent } from '../kullanicigruplar/kullanici-gruplar.component';
import { KullanicilarComponent } from '../kullanicilar/kullanicilar.component';
import { SubelerComponent } from '../subeler/subeler.component';
import { TaleplerComponent } from '../talepler/talepler.component';
import { AuthGuard } from '../auth/auth.guard';
import { TalepTurlerComponent } from '../talep-turler/talep-turler.component';
import { UrunGruplarComponent } from '../urun-gruplar/urun-gruplar.component';
import { TalepOlusturulduComponent } from '../talep-olusturuldu/talep-olusturuldu.component';
import { SubeEkleDuzenleComponent } from '../sube-ekle-duzenle/sube-ekle-duzenle.component';
import { KullaniciEkleDuzenleComponent } from '../kullanici-ekle-duzenle/kullanici-ekle-duzenle.component';
import { TalepTurEkleDuzenleComponent } from '../talep-tur-ekle-duzenle/talep-tur-ekle-duzenle.component';
import { UrunGrupEkleDuzenleComponent } from '../urun-grup-ekle-duzenle/urun-grup-ekle-duzenle.component';
import { KullaniciGrupEkleDuzenleComponent } from '../kullanici-grup-ekle-duzenle/kullanici-grup-ekle-duzenle.component';
import { TalepOnaySeviyelerComponent } from '../talep-onay-seviyeler/talep-onay-seviyeler.component';
import { TalepOnaySeviyeEkleDuzenleComponent } from '../talep-onay-seviye-ekle-duzenle/talep-onay-seviye-ekle-duzenle.component';
import { TalepComponent } from '../talep/talep.component';
import { CarilerComponent } from '../cariler/cariler.component';
import { CariEkleDuzenleComponent } from '../cari-ekle-duzenle/cari-ekle-duzenle.component';
import { TekliflerComponent } from '../teklifler/teklifler.component';
import { TeklifComponent } from '../teklif/teklif.component';
import { TeklifOlusturulduComponent } from '../teklif-olusturuldu/teklif-olusturuldu.component';
import { SiparislerComponent } from '../siparisler/siparisler.component';
import { SiparisOlusturulduComponent } from '../siparis-olusturuldu/siparis-olusturuldu.component';
import { SiparisOlusturComponent } from '../siparis-olustur/siparis-olustur.component';
import { SiparisComponent } from '../siparis/siparis.component';
import { IrsaliyelerComponent } from '../irsaliyeler/irsaliyeler.component';
import { FaturalarComponent } from '../faturalar/faturalar.component';
import { IrsaliyeComponent } from '../irsaliye/irsaliye.component';
import { FaturaComponent } from '../fatura/fatura.component';
import { NotFoundComponent } from '../not-found/not-found.component';
import { MasterListComponent } from '../master-list/master-list.component';
import { MasterComponent } from '../master/master.component';
import { FaturaOlusturulduComponent } from '../fatura-olusturuldu/fatura-olusturuldu.component';
import { CariKayitModalComponent } from '../cari-kayit-modal/cari-kayit-modal.component';
import { TeklifIstemeFormuComponent } from '../teklif-isteme-formu/teklif-isteme-formu.component';
import { TeklifOlusturulduPublicComponent } from '../teklif-olusturuldu-public/teklif-olusturuldu-public.component';
import { RotaOlusturComponent } from 'src/rota-olustur/rota-olustur.component';
import { LojistikComponent } from 'src/lojistik/lojistik.component';
import { RotaOlusturulduComponent } from 'src/rota-olusturuldu/rota-olusturuldu.component';
import { LojistikFiyatArsivlerComponent } from 'src/lojistik-fiyat-arsivler/lojistik-fiyat-arsivler.component';
import { LojistikFiyatArsivOlusturComponent } from 'src/lojistik-fiyat-arsiv-olustur/lojistik-fiyat-arsiv-olustur.component';
import { LojistikRotaFiyatlarComponent } from 'src/lojistik-rota-fiyatlar/lojistik-rota-fiyatlar.component';
import { TasimaciComponent } from 'src/tasimaci/tasimaci.component';
import { KantarComponent } from 'src/kantar/kantar.component';
import { DuyurularComponent } from '../duyurular/duyurular.component';
import { DuyuruEkleComponent } from 'src/duyuru-ekle/duyuru-ekle.component';
import { IrsaliyeLojistikRotaFiyatComponent } from 'src/irsaliye-lojistik-rota-fiyat/irsaliye-lojistik-rota-fiyat.component';
import { RotaGecmisComponent } from 'src/rota-gecmis/rota-gecmis.component';


const routes: Routes = [
  // guest areas
  { path: '', redirectTo: 'anasayfa', pathMatch: 'full' },
  { path: '404', component: NotFoundComponent },
  { path: 'giris', component: GirisComponent },
  { path: 'anasayfa', component: AnasayfaComponent, canActivate: [AuthGuard] },
  { path: 'kullanici-gruplar', component: KullaniciGruplarComponent, canActivate: [AuthGuard] },
  { path: 'kullanici-grup', component: KullaniciGrupEkleDuzenleComponent, canActivate: [AuthGuard] },
  { path: 'kullanici', component: KullaniciEkleDuzenleComponent, canActivate: [AuthGuard] },
  { path: 'kullanicilar', component: KullanicilarComponent, canActivate: [AuthGuard] },
  { path: 'sube', component: SubeEkleDuzenleComponent, canActivate: [AuthGuard] },
  { path: 'subeler', component: SubelerComponent, canActivate: [AuthGuard] },
  { path: 'talepler', component: TaleplerComponent, canActivate: [AuthGuard] },
  { path: 'talep-turler', component: TalepTurlerComponent, canActivate: [AuthGuard] },
  { path: 'talep-tur', component: TalepTurEkleDuzenleComponent, canActivate: [AuthGuard] },
  { path: 'urun-gruplar', component: UrunGruplarComponent, canActivate: [AuthGuard] },
  { path: 'urun-grup', component: UrunGrupEkleDuzenleComponent, canActivate: [AuthGuard] },
  { path: 'talep', component: TalepComponent, canActivate: [AuthGuard] },
  { path: 'talep-olusturuldu', component: TalepOlusturulduComponent, canActivate: [AuthGuard] },
  { path: 'talep-onay-seviyeler', component: TalepOnaySeviyelerComponent, canActivate: [AuthGuard] },
  { path: 'talep-onay-seviye', component: TalepOnaySeviyeEkleDuzenleComponent, canActivate: [AuthGuard] },
  { path: 'cari', component: CariEkleDuzenleComponent, canActivate: [AuthGuard] },
  { path: 'cariler', component: CarilerComponent, canActivate: [AuthGuard] },
  { path: 'teklifler', component: TekliflerComponent, canActivate: [AuthGuard] },
  { path: 'teklif', component: TeklifComponent, canActivate: [] },
  { path: 'teklif-olusturuldu', component: TeklifOlusturulduComponent, canActivate: [] },
  { path: 'siparisler', component: SiparislerComponent, canActivate: [AuthGuard] },
  { path: 'siparis-olustur', component: SiparisOlusturComponent, canActivate: [AuthGuard] },
  { path: 'siparis-olusturuldu', component: SiparisOlusturulduComponent, canActivate: [AuthGuard] },
  { path: 'siparis', component: SiparisComponent, canActivate: [AuthGuard] },
  { path: 'irsaliyeler', component: IrsaliyelerComponent, canActivate: [AuthGuard] },
  { path: 'irsaliye', component: IrsaliyeComponent, canActivate: [AuthGuard] },
  { path: 'faturalar', component: FaturalarComponent, canActivate: [AuthGuard] },
  { path: 'fatura', component: FaturaComponent, canActivate: [AuthGuard] },
  { path: 'master-list', component: MasterListComponent, canActivate: [AuthGuard] },
  { path: 'master', component: MasterComponent, canActivate: [AuthGuard] },
  { path: 'fatura-olusturuldu', component: FaturaOlusturulduComponent, canActivate: [AuthGuard] },
  { path: 'cari-bilgi-formu', component: CariKayitModalComponent },
  { path: 'teklif-isteme-formu', component: TeklifIstemeFormuComponent },
  { path: 'teklif-olusturuldu-public', component: TeklifOlusturulduPublicComponent },
  { path: 'rota-olustur', component: RotaOlusturComponent, canActivate: [AuthGuard] },
  { path: 'lojistik', component: LojistikComponent, canActivate: [AuthGuard] },
  { path: 'rota-olusturuldu', component: RotaOlusturulduComponent, canActivate: [AuthGuard] },
  { path: 'lojistik-fiyat-arsivler', component: LojistikFiyatArsivlerComponent, canActivate: [AuthGuard] },
  { path: 'lojistik-fiyat-arsiv-olustur', component: LojistikFiyatArsivOlusturComponent, canActivate: [AuthGuard] },
  { path: 'lojistik-rota-fiyatlar', component: LojistikRotaFiyatlarComponent, canActivate: [AuthGuard] },
  { path: 'irsaliye-lojistik-rota-fiyat', component: IrsaliyeLojistikRotaFiyatComponent, canActivate: [AuthGuard] },
  { path: 'tasimaci', component: TasimaciComponent },
  { path: 'kantar', component: KantarComponent, canActivate: [AuthGuard] },
  { path: 'duyurular', component: DuyurularComponent, canActivate: [AuthGuard] },
  { path: 'duyuru-ekle', component: DuyuruEkleComponent, canActivate: [AuthGuard] },
  { path: 'rota-gecmis', component: RotaGecmisComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}

export const router: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });
